import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Link } from 'react-router-dom';
import '../styles/Dashboard.css';

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

function Dashboard() {
  const [data, setData] = useState({
    applied: [],
    interview: [],
    hired: [],
    rejected: [],
  });

  useEffect(() => {
    const fetchApplicantsData = async () => {
      // Replace this with actual data fetching from your database
      const dataFromCandidates = {
        applied: [
          { id: '1', name: 'Rehana Nicole Ruilan' },
          { id: '2', name: 'Alliyah Renos' },
        ],
        interview: [
          { id: '3', name: 'Christine Sevilla' },
        ],
        hired: [
          { id: '4', name: 'Jayrille Tubera' },
        ],
        rejected: [
          { id: '5', name: 'Missy Smith' },
        ],
      };

      setData(dataFromCandidates);
    };

    fetchApplicantsData();
  }, []);

  const lineChartData = {
    labels: ['Applied', 'Interview', 'Hired', 'Rejected'],
    datasets: [
      {
        label: 'Number of Applicants',
        data: [
          data.applied.length,
          data.interview.length,
          data.hired.length,
          data.rejected.length,
        ],
        backgroundColor: 'rgba(75,192,192,0.2)',
        borderColor: 'rgba(75,192,192,1)',
        borderWidth: 2,
        pointBackgroundColor: 'rgba(75,192,192,1)',
        pointBorderColor: '#fff',
        tension: 0.4,
      },
    ],
  };

  const lineChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top',
        labels: {
          font: {
            family: "'Roboto', sans-serif",
            weight: 'bold',
            size: 14,
          },
        },
      },
      tooltip: {
        backgroundColor: 'rgba(0,0,0,0.7)',
        bodyColor: '#fff',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Number of Applicants',
          font: {
            family: "'Roboto', sans-serif",
            weight: 'bold',
            size: 16,
          },
        },
      },
      x: {
        title: {
          display: true,
          text: 'Stages',
          font: {
            family: "'Roboto', sans-serif",
            weight: 'bold',
            size: 16,
          },
        },
      },
    },
  };

  return (
    <div className="dashboard-container">
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-header">
          <h2>APPLYGABAY</h2>
        </div>
        <ul className="sidebar-links">
          <li>
            <Link to="/" className="sidebar-link active">Dashboard</Link>
          </li>
          <li>
            <Link to="/jobs" className="sidebar-link">Jobs</Link>
          </li>
          <li>
            <Link to="/candidates" className="sidebar-link">Candidates</Link>
          </li>
          <li>
            <Link to="/tasks" className="sidebar-link">Tasks</Link>
          </li>
          <li>
            <Link to="/settings" className="sidebar-link">Settings</Link>
          </li>
        </ul>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        <header className="dashboard-header">
          <h1>Applicant Tracking System</h1>
          <div className="header-icons">
            <span role="img" aria-label="search">🔍</span>
            <span role="img" aria-label="notifications">🔔</span>
            <span role="img" aria-label="settings">⚙️</span>
          </div>
        </header>

        {/* Line Chart Section */}
        <section className="dashboard-chart">
          <h2>Applicant Data Overview</h2>
          <div className="chart-container">
            <Line data={lineChartData} options={lineChartOptions} />
          </div>
        </section>
      </main>
    </div>
  );
}

export default Dashboard;
